// ServiceList.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, List, ListItem } from '@chakra-ui/react';

const ServiceList = ({ services, onSelectService }) => {
  const navigate = useNavigate();
  const location = useLocation();
  if (!services?.length) return null; // If there are no services, don't render anything

  return (
    <Box className="service-list">
      <List spacing={3}>
        {services.map((service) => (
          <Box className="actionableItem"
            key={service._id} 
            onClick={() => navigate({
              pathname: `/appointments/new/service/${service.id}`,
              search: location.search 
            })} 
            cursor="pointer"
            _hover={{ bg: 'gray.100' }}
            border="1px"
            borderColor="gray.200"
            borderRadius="md"
            p={4}
          >
            {service.name}
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default ServiceList;
